module.exports = __webpack_public_path__ + "img/wrench-and-screwdriver-cross.46cfa55e.svg";